import React from 'react'
import { Col, DatePicker, Form, Popconfirm, Row } from 'antd'
import { get, isEmpty } from 'lodash'
import CustomSelect from '../../../elements/Select/CustomSelect'
import { compose } from 'recompose'
import { dateVal } from '../../../modules/Utils'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import withSpinning from '../../../elements/HOC/withSpinning'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import withSort from '../../../elements/HOC/withSort'
import RefreshButton from '../../../elements/Buttons/RefreshButton'
import { strVal } from '../../../modules/Utils'
import Status from '../../../elements/Status'
import EmployeeSelect from '../../../elements/Select/Employee/EmployeesSelect'
import { fullWidthFormItemLayout, defaultFormItemLayout, rules } from '../../../modules/FormItems'
import { MODAL_TYPE_NEW } from '../../../elements/Hooks/useModalData'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import { formatQueryParams } from '../../../modules/Utils'
import { BUDGET_TYPE_SALES } from '../../../components/Common/Budgets/BudgetCont'
import { BUDGET_TYPE_INTERNAL } from '../../../components/Common/Budgets/BudgetCont'

const CategorySelect = compose(
  withSelectFetch({
    dropdown: 'claims',
    name: 'category',
    cache: true,
  }),
  withSpinning,
  withSort
)(CustomSelect)

function ClaimsForm(props) {
  const { getFieldDecorator, resetFields, getFieldValue } = props.form
  const {
    claim,
    modalType,
    member,
    option,
    fetchClaim,
    actions,
    handleOps,
    // SalesSelect,
    onChangeSales,
    onChangeMAC,
  } = props
  const salesOrdersUrl = `sales/?select=*&status=Approved`
  const [SalesSelect] = useFetchSelectUrl(
    {
      name: 'clients_order',
      url: salesOrdersUrl,
      cache: true,
      forceFetch: true,
    },
    [salesOrdersUrl],
    undefined,
    undefined,
    (c) => ({ ...c, display: `[${c.code}]  ${strVal(c, 'title')}` })
  )

  const Operations = ({ claim, ...rest }) => {
    const ops = actions.map((a) => (
      <span>
        <Popconfirm
          placement="left"
          title={`Are you sure to ${a.value}?`}
          onConfirm={() => handleOps(a.key, claim)}
          okText="Yes"
          cancelText="No">
          <a>{a.value}</a>
        </Popconfirm>
      </span>
    ))
    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr])
          : []}
      </div>
    )
  }
  const status = get(claim, 'status')
  const [CompaniesSelect] = useFetchSelectUrl(
    {
      name: 'companies',
      url: `/labourContracts/activeCompanies?id=${
        getFieldValue('claimant._id') || get(member, '_id') || get(claim, 'claimant._id')
      }`,
    },
    [getFieldValue('claimant._id'), get(claim, 'claimant._id'), get(member, '_id')],
    isEmpty(getFieldValue('claimant._id')) &&
      isEmpty(get(member, '_id')) &&
      isEmpty(get(claim, 'claimant._id'))
  )
  const budgetDropdownUrl = `budgets/?dropdown=true&select=*&status=Approved${formatQueryParams(
    'budgetType',
    getFieldValue('category') === 'Project' ? BUDGET_TYPE_SALES : BUDGET_TYPE_INTERNAL
  )}${formatQueryParams('company', getFieldValue('company._id'))}`
  const [BudgetSelect] = useFetchSelectUrl(
    {
      name: 'budgets',
      url: budgetDropdownUrl,
      cache: false,
    },
    [budgetDropdownUrl]
  )

  return (
    <Form>
      <Row>
        <Row>
          {modalType !== MODAL_TYPE_NEW && option !== 'personal' && (
            <h3 style={{ marginBottom: '25px' }}>
              <RefreshButton onClick={() => fetchClaim(claim._key)} />
              <Status tooltip={false} value={status} />
              <Operations
                style={{ marginTop: '10px' }}
                claim={claim}
                status={strVal(claim, 'status')}
              />
            </h3>
          )}
        </Row>
        <Row>
          {option !== 'personal' && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Employee'}>
                {getFieldDecorator('claimant._id', {
                  initialValue: get(claim, 'claimant._id'),
                  rules: rules.select,
                })(<EmployeeSelect />)}
              </Form.Item>
            </Col>
          )}
          {(getFieldValue('claimant._id') || get(member, '_id')) && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Company'}>
                {getFieldDecorator('company._id', {
                  initialValue: get(claim, 'company._id'),
                  rules: [{ required: true, message: 'Please Select a Company!' }],
                })(<CompaniesSelect keyAtr={'_id'} valueAtr={'fn'} placeholder={'Company'} />)}
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Date'}>
              {getFieldDecorator('date', {
                initialValue: dateVal(claim, 'date'),
                rules: [{ required: true, message: 'Please Select a Date!' }],
              })(<DatePicker style={{ width: '100%' }} placeholder={'Date'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Category'}>
              {getFieldDecorator('category', {
                initialValue: get(claim, 'category'),
                rules: [{ required: true, message: 'Please Select a Category!' }],
              })(
                <CategorySelect
                  placeholder={'Category'}
                  onChange={() => resetFields(['budget._id'])}
                />
              )}
            </Form.Item>
          </Col>
          {['Project', 'Internal'].includes(getFieldValue('category')) && (
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label={'Existing Budget'}>
                {getFieldDecorator('budget._id', {
                  initialValue: get(claim, 'budget._id'),
                  rules: [
                    {
                      required: true,
                      message: "Existing Budget can't be empty",
                    },
                  ],
                })(<BudgetSelect keyAtr={'_id'} valueAtr={'title'} />)}
              </Form.Item>
            </Col>
          )}
        </Row>
        {getFieldValue('category') === 'Project' && (
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Sales'}>
                {getFieldDecorator('sales._id', {
                  initialValue: get(claim, 'sales._id'),
                  rules: [{ required: true, message: "Sales Can't be Empty!" }],
                })(
                  <SalesSelect
                    onChange={onChangeSales}
                    placeholder={'Sales'}
                    keyAtr={'_id'}
                    valueAtr={'display'}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        )}
      </Row>
    </Form>
  )
}

ClaimsForm.propTypes = {}
ClaimsForm.defaultProps = {}

export default compose(Form.create(), withLoadingSection)(ClaimsForm)
